// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M7.75011 4C7.75011 2.61929 8.8694 1.5 10.2501 1.5C11.6308 1.5 12.7501 2.61929 12.7501 4V8H14.7094C15.2406 8 15.7622 8.14103 16.221 8.40866L20.3506 10.8176C21.5771 11.5331 22.134 13.0105 21.685 14.3576L19.6546 20.4487C19.2463 21.6737 18.0999 22.5 16.8086 22.5H8.73492C7.80351 22.5 6.92493 22.0674 6.35705 21.3291L1.52051 15.0416L2.54659 13.5025C2.99614 12.8282 3.80821 12.4918 4.60292 12.6508L7.75011 13.2802V4Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-gesture-up-filled')
export default class GestureUpFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'gesture-up-filled',
    }
  }
}
